import React from "react";
import {ListGroup} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinusCircle} from "@fortawesome/free-solid-svg-icons";
import TextSlider from "../textSlider";


export default function RulesEditOverlapEntry(props) {



    function setPoints(val){
        props.data.grading = val;
        props.cb(props.data);
    }
    function setPercentage(val) {
        props.data.percentage = val;
        props.cb(props.data);
    }
    function setDistance(val) {
        props.data.threshold = val;
        props.cb(props.data);
    }

    function setOtherStruct(val) {
        props.data.otherOrgan = val;
        props.cb(props.data);
    }




    return (
                <ListGroup.Item className="d-flex justify-content-between align-items-start">
                    <span>
                        Penalise grade by
                    <TextSlider
                        min={0}
                        max={100}
                        value={props.data.grading}
                        onChange={setPoints}
                        display={(value) => <span> ( {value} ) points</span>}
                    />
                    if
                    <TextSlider
                        min={0}
                        max={100}
                        value={props.data.percentage}
                        onChange={setPercentage}
                        display={(value) => <span>( {value}% )</span>}
                    />
                    overlaps with
                    <TextSlider
                        rate={0.1}
                        min={0}
                        max={100}
                        value={props.data.threshold}
                        onChange={setDistance}
                        display={(value) => <span>({value} mm)</span>}
                    />
                    over
                    <select value={props.data.otherOrgan} onChange={(e)=>{setOtherStruct(e.target.value)}}>
                        {props.otherStructs.map((val,i) =>
                            <option key={i}>{val}</option>
                        )}
                    </select>
                    </span>
                    <button onClick={() => props.cb(null)} className="ms-2 btn btn-link text-danger">
                        <FontAwesomeIcon className="pe-auto" icon={faMinusCircle} />
                    </button>
                </ListGroup.Item>


    )
}